import React from 'react';
import {List, Datagrid, TextField, ArrayField, SingleFieldList, ChipField, EditButton, Pagination} from 'react-admin';
import {HASHTAG_RECOMMEND_LIST, HASH_TAG} from '../../consts/Names';

export const HashTagRecommendList = (props) => {
   return (
      <List {...props} title="Recommended" bulkActionButtons={false} exporter={false}  perPage={25} pagination={<Pagination rowsPerPageOptions={[25,50,100,200]}/>}>
         <Datagrid>
            <TextField source={HASHTAG_RECOMMEND_LIST.id} sortable={false} />
            <TextField source={HASHTAG_RECOMMEND_LIST.name} sortable={false} />
            <ArrayField label="Related tags" source={'tags'} sortable={false}>
               <SingleFieldList linkType={false}>
                  <ChipField source={HASH_TAG.name} />
               </SingleFieldList>
            </ArrayField>
            <EditButton />
         </Datagrid>
      </List>
   );
};
